// update descblock input
// update descblock response
// update traveller info
// update pc
// update profile type
// update gocash usage
// make provisional booking
// init payment

import {
  UPDATE_DESCBLOCK_DATA,
  UPDATE_DESCBLOCK_INPUT,
  UPDATE_HOTELS_PAYMENTS_DATA,
  UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
  UPDATE_USEGOCASH_STATUS,
  RESET_PAYMENTS_DATA,
  UPDATE_DESCBLOCK_LOADING_STATUS,
  UPDATE_EARLYCHECKIN_STATUS,
  UPDATE_COUNTRY_CODES,
  UPDATE_HOTELS_POLICY,
  RESET_REVIEW_PAGE_DATA,
  TOGGLE_AGREE_TNC,
  UPDATE_OFFERS_FROM_HERMES,
  UPDATE_DONATE_CHARITY_STATUS,
  UPDATE_ACTIVE_PAYMODE,
  TOGGLE_POLICIES_MODAL,
} from './constants';
import {
  IUpdateDescBlockData,
  IUpdatePaymentsData,
  IUpdatePaymentModuleOpenClose,
  IUpdateUseGoCash,
  IResetPaymentsData,
  IUpdateDescblockLoadingStatus,
  IUpdateEarlyCheckinStatus,
  IReviewPageData,
  IToggleTnCAgreement,
  IUpdateOffersFromHermes,
  IUpdateActivePaymode,
  ITogglePoliciesModal,
} from './hotels-review-types';

export function updateDescblockData(
  actionData: IUpdateDescBlockData['actionData'],
): IUpdateDescBlockData {
  return {
    type: UPDATE_DESCBLOCK_DATA,
    actionData,
  };
}

export function updateDescblockInput(
  actionData: IUpdateDescBlockData['actionData'],
): IUpdateDescBlockData {
  return {
    type: UPDATE_DESCBLOCK_INPUT,
    actionData,
  };
}

export function updatePaymentsData(actionData: any): IUpdatePaymentsData {
  return {
    type: UPDATE_HOTELS_PAYMENTS_DATA,
    actionData,
  };
}

export function closePaymentModule(): IUpdatePaymentModuleOpenClose {
  return {
    type: UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
    status: false,
  };
}

export function resetPaymentsData(): IResetPaymentsData {
  return {
    type: RESET_PAYMENTS_DATA,
  };
}
export function resetReviewPageData(): IReviewPageData {
  return {
    type: RESET_REVIEW_PAGE_DATA,
  };
}

export function openPaymentModule(): IUpdatePaymentModuleOpenClose {
  return {
    type: UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
    status: true,
  };
}

export function updateUseGocashStatus(value: boolean): IUpdateUseGoCash {
  return {
    type: UPDATE_USEGOCASH_STATUS,
    status: value,
  };
}

export function setDescblockLoading(value: boolean): IUpdateDescblockLoadingStatus {
  return {
    type: UPDATE_DESCBLOCK_LOADING_STATUS,
    status: value,
  };
}

export function updateEarlyCheckInStatus(value: boolean): IUpdateEarlyCheckinStatus {
  return {
    type: UPDATE_EARLYCHECKIN_STATUS,
    status: value,
  };
}

export function updateCountryCodes(actionData) {
  return {
    type: UPDATE_COUNTRY_CODES,
    actionData,
  };
}

export function updateHotelsPolicy(actionData = {}) {
  return {
    type: UPDATE_HOTELS_POLICY,
    actionData,
  };
}

export function toggleTncAgreement(actionData: boolean): IToggleTnCAgreement {
  return {
    type: TOGGLE_AGREE_TNC,
    actionData,
  };
}

export function updatePayCharity(actionData: boolean): IToggleTnCAgreement {
  return {
    type: UPDATE_DONATE_CHARITY_STATUS,
    actionData,
  };
}

export function updateOffersFromHermes(
  actionData: IUpdateOffersFromHermes['actionData'],
): IUpdateOffersFromHermes {
  return {
    type: UPDATE_OFFERS_FROM_HERMES,
    actionData,
  };
}
export function updateActivePaymode(actionData: number): IUpdateActivePaymode {
  return {
    type: UPDATE_ACTIVE_PAYMODE,
    actionData,
  };
}

export function togglePoliciesModal(actionData: boolean): ITogglePoliciesModal {
  return {
    type: TOGGLE_POLICIES_MODAL,
    actionData,
  };
}
